<template>
	<div class="increment">
		<div class="increment-page-content">
			<div class="title">就诊流程增项</div>
			<div class="content">
				<a-form>
					<a-row class="input-row">
						<a-col :span="24">
							<a-form-item
									:validate-status="isSubmit&&!formData.applyItemName?'error':''"
									:help="isSubmit&&!formData.applyItemName?'请选择检测项目':''"
							>
								<div class="name hospital-required">检测项目</div>
								<div>
									<a-select
											style="width:100%;"
											disabled="disabled"
											v-model="formData.applyItemName"
											placeholder="请选择检测项目"
									>
										<a-select-option
												v-for="item in applyItems"
												:key="item.dictKey"
												:value="item.dictKey+''"
										>{{item.dictValue}}
										</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col :span="24">
							<div class="confirm-tip">您确认要增项吗？</div>
						</a-col>
					</a-row>
				</a-form>
				<div class="footer">
					<a-button :loading="isHttpSubmit" @click="submit()" type="primary">确定</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import {regAll} from "../../common/validate";

  export default {
    props: {
      iData: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        sampleTypes: [],
        applyItems: [],
        isSubmit: false,
        isHttpSubmit: false,
        formData: {
          applyItemName: undefined,
          groupName: "",
          sampleAmount: ""
        }
      };
    },
    mounted() {
      this.formData = this.iData;
      this.getDirt("sampleType").then(data => {
        this.sampleTypes = data.rows;
      });
      // this.getDirt("applyItem").then(data => {
      //   this.applyItems = data.rows;
      // });
      this.getProject();
    },
    methods: {
      submit() {
        this.isSubmit = true;
        // this.isHttpSubmit = true;
        this.$nextTick(() => {
          const isPass =
            document.querySelectorAll(".ant-form-explain").length == 0;
          if (isPass) {
            this.$emit("ok", this.formData);
          }
        });
      },
      isOkNum(num) {
        if (this.formData.sampleAmount) {
          if (!regAll.regNum2.test(this.formData.sampleAmount)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      getProject() {
        this.$get("patientitem/patientItem/getApplyItem", {
          hosBarCode: this.formData.hosBarCode,
          barCode: this.formData.barCode
        }).then(res => {
          this.applyItems = res.data.data;
        });
      },
      getDirt(dictType) {
        return new Promise((resolve, reject) => {
          this.$get("info/commonDict", {
            dictType: dictType,
            pageSize: 10000
          }).then(
            res => {
              resolve(res.data.data);
            },
            err => {
              reject(err);
            }
          );
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.increment {
		width: 100%;
		height: 100%;
		background: #fff;
		overflow: auto;
		.increment-page-content {
			width: 682px;
			margin: 80px auto 40px;
			.title {
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
				margin-bottom: 50px;
			}
			.content {
				border: 1px solid rgba(243, 245, 247, 1);
				padding: 30px 46px;
				width: 100%;
				.input-row {
					.name {
						font-size: 13px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(164, 164, 164, 1);
						line-height: 14px;
						margin-bottom: 10px;
					}
					.left {
						padding-right: 26px;
					}
					.right {
						padding-left: 26px;
					}
				}
			}
			.confirm-tip {
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #333333;
				margin: 0px 0 20px 0;
			}
			.footer {
				.ant-btn {
					width: 100%;
				}
			}
		}
	}
</style>